import styled, { css } from "styled-components";

type TCard = {
  size?: "sm" | "lg";
  background?: string;
  color?: string;
  noPadding?: boolean;
};

export const Container = styled("div")`
  display: flex;
  justify-content: center;
`;

export const Content = styled.div`
  font-family: Kanit;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 2rem 0;
  max-width: 1200px;

  h1 {
    font-weight: 500;
  }

  span {
    font-family: "Open Sans";
    text-align: center;
    font-size: 18px;
    margin: 0.25rem;
    margin-top: 48px;
  }

  @media (max-width: 1200px) {
    span {
      font-size: 16px;
    }
  }

  a {
    color: #6c5af4;
  }

  #repproved {
    @media (min-width: 900px) {
      min-width: 550px;
      min-height: 336px;
    }
  }

  .img {
    max-width: 400px;
    width: 100%;
    max-height: 768px;
    min-height: auto;
    background-size: 100%;
    background-repeat: no-repeat;
    margin: 0 auto;
    display: block;

    @media only screen and (max-width: 600px) {
      width: auto;
      max-height: 250px;
      min-height: auto;
      background-size: 100%;
      background-repeat: no-repeat;
      display: block;
    }
  }
`;

const CardSizeStyles = {
  sm: {
    maxWidth: "340px",
    padding: "1rem",
  },
  lg: {
    maxWidth: "1100px",
    padding: "1.75rem 2.75rem",
  },
};

export const Card = styled("div").withConfig({
  shouldForwardProp: (prop) =>
    !["size", "background", "noPadding"].includes(prop),
})<TCard>`
  width: ${({ size }) => CardSizeStyles[size || "sm"].maxWidth};
  color: ${({ color }) => (color ? color : "#000000")};
  background-color: ${({ background }) =>
    background ? background : "#ffffff"};
  border-radius: 16px;
  box-shadow: 0px 10px 20px 0px #0000001f;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  padding: ${({ size, noPadding }) =>
    !noPadding ? CardSizeStyles[size || "sm"].padding : "0.5rem"};
  margin: 0.5rem;
  gap: 1.5rem;

  h2 {
    font-size: 24px;
    font-weight: 300;
  }

  @media (max-width: 1314px) {
    h2 {
      font-size: 14px;
    }

    ${({ size }) =>
      size === "lg" &&
      css`
        max-width: 75dvw;
      `}
  }

  @media (min-width: 930px) and (max-width: 1200px) {
    ${({ size }) =>
      size === "sm" &&
      css`
        max-width: 260px;
      `}
  }

  @media (max-width: 700px) {
    ${({ size }) =>
      size === "sm" &&
      css`
        width: 85dvw;
      `}
  }
`;

export const InfoContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 930px) {
    flex-direction: column;
  }
`;

export const InfoColumn = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CardSmContainer = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  align-items: flex-start;
  h2 {
    font-size: 22px;
    font-weight: 400;
    margin: 0;
  }

  h1 {
    font-family: "Open Sans", sans-serif;
    font-size: 24px;
    color: #6c5af4;
    font-weight: 700;
    margin: 0;
  }

  p {
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;

    margin: 0;
    text-align: start;
    color: #616161;
  }

  @media (min-width: 930px) and (max-width: 1200px) {
    h1 {
      font-size: 18px;
    }

    h2 {
      font-size: 16px;
    }
  }
`;

export const CardLgContainer = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  h1 {
    font-family: Kanit;
    font-size: 22px;
    font-weight: 500;
    margin: 0.5rem 0;
  }

  span,
  h2 {
    font-family: "Open Sans", sans-serif;
  }

  h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #6c5af4;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  span {
    font-size: 16px;
    font-weight: 400;
    color: #212121;
  }
`;

export const DataSection = styled("div")`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 25%);

  & > div {
    margin-bottom: 0.75rem;
  }

  @media (max-width: 700px) {
    gap: 1rem;
    grid-template-columns: 1fr;
    & > div {
      margin-bottom: 0.5rem;
    }
  }
`;
